import Vue from 'vue'
import VueRouter from 'vue-router'

// Views
import Landing from '../views/Landing/Landing.vue'
import Explore from '../views/Explore/Explore.vue'
import Menu from '../views/Menu/Menu.vue'
import Cart from '../views/Cart/Cart.vue'
import Checkout from '../views/Checkout/Checkout.vue'
import OrderHistory from '../views/History/History.vue'
import Order from '../views/History/Order.vue'
import Login from '../views/Accounts/Login.vue'
import Profile from '../views/Accounts/Profile.vue'
import Franchise from '../views/Franchise/Franchise.vue'
import Branch from '../views/Branch/Branch.vue'
import Register from '../views/Accounts/Register.vue'
import Registered from '../views/Accounts/Registered.vue'
import Activate from '../views/Accounts/Activate.vue'
import Recover from '../views/Accounts/Recover.vue'
import OrdersUnavailable from '../views/Accounts/OrdersUnavailable.vue'
import PasswordChange from '../views/Accounts/PasswordChange.vue'
import OnlinePayments from '../views/OnlinePayments/OnlinePayments.vue'
import Payment from '../views/Payment/Payment.vue'
import Tab from '../views/Tab/Tab.vue'
import Pay from '../views/Pay/Pay.vue'
import Success from '../views/Responses/Success.vue'
import Cancel from '../views/Responses/Cancel.vue'
import ComingSoon from '../views/Responses/ComingSoon.vue'
import Finalize from '../views/Responses/Finalize.vue'
import TransactionCompleted from '../views/Responses/TransactionCompleted.vue'
import QRCScanner from '../views/QRCScanner/QRCScanner.vue'
import Seating from '../views/Seating/Seating.vue'

Vue.use(VueRouter)

var routes = [
  {
    path: '/onlinePayments',
    name: 'OnlinePayments',
    component: OnlinePayments
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/pay',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/success',
    name: 'Success',
    component: Success
  },
  {
    path: '/cancel',
    name: 'Cancel',
    component: Cancel
  },
  {
    path: '/comingsoon',
    name: 'ComingSoon',
    component: ComingSoon
  },
  {
    path: '/finalize',
    name: 'Finalize',
    component: Finalize
  },
  {
    path: '/qrcscanner',
    name: 'QRCScanner',
    component: QRCScanner
  },
  {
    path: '/transactionCompleted',
    name: 'TransactionCompleted',
    component: TransactionCompleted
  },
]

if (window.config.EnableComingSoon) {
  routes.push(
    {
      path: '/',
      name: '/',
      component: ComingSoon
    },
    {
      path: '/menu',
      name: 'Menu',
      component: ComingSoon
    },
    {
      path: '/explore',
      name: 'Explore',
      component: ComingSoon
    },
    {
      path: '/cart',
      name: 'Cart',
      component: ComingSoon
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: ComingSoon
    },
    {
      path: '/history',
      name: 'History',
      component: ComingSoon
    },
    {
      path: '/order',
      name: 'Order',
      component: ComingSoon
    },
    {
      path: '/login',
      name: 'Login',
      component: ComingSoon
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ComingSoon
    },
    {
      path: '/franchise',
      name: 'Franchise',
      component: ComingSoon
    },
    {
      path: '/branch',
      name: 'Branch',
      component: ComingSoon
    },
    {
      path: '/register',
      name: 'Register',
      component: ComingSoon
    },
    {
      path: '/registered',
      name: 'Registered',
      component: ComingSoon
    },
    {
      path: '/activate',
      name: 'Activate',
      component: ComingSoon
    },
    {
      path: '/recover',
      name: 'Recover',
      component: ComingSoon
    },
    {
      path: '/ordersUnavailable',
      name: 'OrdersUnavailable',
      component: ComingSoon
    },
    {
      path: '/passwordChange',
      name: 'PasswordChange',
      component: ComingSoon
    },
    {
      path: '/tab',
      name: 'Tab',
      component: ComingSoon
    });
}
else {
  routes.push(
    {
      path: '/',
      name: '/',
      component: Landing
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/explore',
      name: 'Explore',
      component: Explore
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/history',
      name: 'History',
      component: OrderHistory
    },
    {
      path: '/order',
      name: 'Order',
      component: Order
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/franchise',
      name: 'Franchise',
      component: Franchise
    },
    {
      path: '/branch',
      name: 'Branch',
      component: Branch
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/registered',
      name: 'Registered',
      component: Registered
    },
    {
      path: '/activate',
      name: 'Activate',
      component: Activate
    },
    {
      path: '/recover',
      name: 'Recover',
      component: Recover
    },
    {
      path: '/ordersUnavailable',
      name: 'OrdersUnavailable',
      component: OrdersUnavailable
    },
    {
      path: '/passwordChange',
      name: 'PasswordChange',
      component: PasswordChange
    },
    {
      path: '/tab',
      name: 'Tab',
      component: Tab
    },
    {
      path: '/seating',
      name: 'Seating',
      component: Seating
    });
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
